import { ApiTable } from "../../../components/table/ApiTable"
import { usePosterOrdersApi } from "../../posters/usePosterOrdersApi"
import Toolbar from "../Toolbar/Toolbar"
import { useSearchText } from "../useSearchText"

export const SuperAdminPosters = () => {
  const { list } = usePosterOrdersApi()
  const { setSearchTextDebounced, queryParams } = useSearchText()
  const columns = [
    {
      header: "Name",
      field: "name"
    },
    {
      header: "Firma",
      cell: (row: any) => <div>{row.company?.name ?? "Brak"}</div>
    },
    {
      header: "Zarejestrowana",
      cell: (row: any) => <div>{row.created_at}</div>
    }
  ]

  return (
    <>
      <Toolbar setSearchTextDebounced={setSearchTextDebounced} api={list} />
      <ApiTable
        columns={columns}
        listApi={list}
        showExpandColumn
        rowLinkBuilder={(row: any) => `/super/posters/${row.id}`}
      ></ApiTable>
    </>
  )
}
